/**
 * ツール定義の一元管理
 * トップページのマーキーバー、use-casesのツールバッジ、下部ツールセクションで共有
 */

export interface ToolInfo {
  name: string
  logo: string
}

/** Sophyが使える全ツール（トップのマーキーバー + ツールセクション共通） */
export const allTools: ToolInfo[] = [
  { name: "Linear", logo: "/images/linear-logo.jpeg" },
  { name: "Notion", logo: "/images/notion-logo.webp" },
  { name: "Slack", logo: "/images/slack-logo.png" },
  { name: "Gmail", logo: "/images/gmail-icon.png" },
  { name: "Google Calendar", logo: "/images/google-calendar-icon.png" },
  { name: "Google Drive", logo: "/images/google-drive-icon.png" },
  { name: "Chatwork", logo: "/images/chatwork-icon.png" },
  { name: "メール", logo: "/images/email-icon.png" },
  { name: "LINE", logo: "/images/line-icon.png" },
  { name: "Microsoft Teams", logo: "/images/teams-icon.png" },
  { name: "Seedance", logo: "/images/seedance-icon.png" },
  { name: "Kling", logo: "/images/kling-icon.png" },
  { name: "TikTok", logo: "/images/tiktok-icon.png" },
  { name: "Instagram", logo: "/images/instagram-icon.png" },
]

/** カードバッジ専用（マーキーバーには出ないが、カードバッジでは表示される） */
const badgeOnlyTools: ToolInfo[] = [
  { name: "Sophy", logo: "/images/sophy_symbol.webp" },
  { name: "天気", logo: "/images/weather-icon.svg" },
  { name: "X", logo: "/images/x-icon.png" },
  { name: "GitHub", logo: "/images/github-icon.png" },
  { name: "Spotify", logo: "/images/spotify-icon.png" },
  { name: "1Password", logo: "/images/1password-icon.svg" },
]

/** name → ToolInfo のルックアップ（allTools + badgeOnlyTools） */
export const toolByName: Record<string, ToolInfo> = Object.fromEntries(
  [...allTools, ...badgeOnlyTools].map((t) => [t.name, t])
)
